/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// May contain unused imports in some cases
// @ts-ignore
import { HhFieldFilterDto } from "./hh-field-filter-dto";
// May contain unused imports in some cases
// @ts-ignore
import { PageDto } from "./page-dto";

/**
 *
 * @export
 * @interface QueryHandHistoryAggregatedRequestDto
 */
export interface QueryHandHistoryAggregatedRequestDto {
  /**
   *
   * @type {Array<HhFieldFilterDto>}
   * @memberof QueryHandHistoryAggregatedRequestDto
   */
  filters: Array<HhFieldFilterDto>;
  /**
   *
   * @type {Array<string>}
   * @memberof QueryHandHistoryAggregatedRequestDto
   */
  group_by: Array<QueryHandHistoryAggregatedRequestDtoGroupByEnum>;
  /**
   *
   * @type {PageDto}
   * @memberof QueryHandHistoryAggregatedRequestDto
   */
  page: PageDto;
}

export const QueryHandHistoryAggregatedRequestDtoGroupByEnum = {
  Room: "ROOM",
  Date: "DATE",
  Pid: "PID",
  StartTime: "START_TIME",
  Profile: "PROFILE",
  Tournament: "TOURNAMENT",
  BuyinUsd: "BUYIN_USD",
  GameType: "GAME_TYPE",
} as const;

export type QueryHandHistoryAggregatedRequestDtoGroupByEnum =
  (typeof QueryHandHistoryAggregatedRequestDtoGroupByEnum)[keyof typeof QueryHandHistoryAggregatedRequestDtoGroupByEnum];
